import React, { useEffect, useRef, useState } from 'react'
import { Rimg } from 'components/images'

export default function VideoWithCover({
	cover,
	coverPosition,
	coverMobilePosition,
	videoUrl,
}) {
	const videoRef = useRef()
	const [isPlaying, setIsPlaying] = useState(false)

	useEffect(() => {
		const isPaused = videoRef.current?.paused
		console.debug('[attr] isPaused', isPaused)

		if (typeof isPaused !== 'boolean') return

		if (!isPaused) {
			console.debug('[attr] not paused')
			setIsPlaying(true)
		}
	}, [videoRef.current?.paused])

	useEffect(() => {
		const videoElement = videoRef.current
		// This was used to force autoplay on iOS Safari, but seems usable for desktop as well
		// const isSafari = !!navigator.userAgent.match(/Version\/[.\d]+.*Safari/)
		// const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
		// if (!iOS) return

		if (isPlaying) {
			console.debug('[listener] already playing => retract')
			return
		}

		function handleOnPlay() {
			console.debug('[onPlay] video started playing => hiding cover')
			setIsPlaying(true)
		}

		function handleOnSuspend() {
			console.debug('[onSuspend] video paused => showing cover')
			setIsPlaying(false)

			console.debug('[onSuspend] video suspended')
			document.body.addEventListener('touchstart', forceAutoPlay)
			document.body.addEventListener('mousemove', forceAutoPlay)

			function forceAutoPlay(e) {
				console.debug(
					'[onSuspend] forcing auto play',
					videoElement instanceof HTMLVideoElement
				)
				videoElement?.play()

				if (!videoElement?.paused) {
					removeListeners()
				}
			}
			function removeListeners() {
				document.body.removeEventListener('touchstart', forceAutoPlay)
				document.body.removeEventListener('mousemove', forceAutoPlay)
				console.debug('[onSuspend] removed listeners')
			}
		}

		console.debug(
			'[listener] should be playing now',
			videoElement.paused,
			videoElement
		)

		videoElement?.addEventListener('play', handleOnPlay)
		videoElement?.addEventListener('suspend', handleOnSuspend)

		return () => {
			videoElement?.removeEventListener('play', handleOnPlay)
			videoElement?.removeEventListener('suspend', handleOnSuspend)
		}
	}, [isPlaying])

	return (
		<div className="relative h-full w-full">
			<video
				className="absolute h-full w-full object-cover"
				autoPlay
				loop
				muted
				playsInline
				preload="metadata"
				ref={videoRef}
				src={videoUrl}
			/>
			{cover && !isPlaying && (
				<Rimg
					className="absolute h-full w-full object-cover"
					image={cover}
					position={coverPosition}
					mobilePosition={coverMobilePosition}
					alt="Seeing is experiencing"
				/>
			)}
		</div>
	)
}
